export const authFeatureKey = 'auth';

export interface State {
  isLoggedIn: boolean;
}

export const initialState: State = {
  isLoggedIn: false,
};
